<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,802.5l-1.46-6.56l-4,2.01l2.01-4l-6.55-1.45l6.55-1.46l-2.01-4l4,2.01l1.46-6.56l1.45,6.56l4-2.01l-2.01,4l6.56,1.46
	l-6.56,1.45l2.01,4l-4-2.01L0.5,802.5z"/>
</svg>

</template>